import { gql } from "@apollo/client";

export const TICKET_AGGREGATION_FRAGMENT = gql`
  fragment TicketAggregation on TicketAggregation {
    count
    status
  }
`;
